import { getFilters } from './context-utils';
import { type TripsContext } from '../types';
import { type Filters } from '../../../types';

export const getOldAndNewFilters = (
  context: TripsContext,
  update: Partial<Filters>
): { old: Filters; new: Filters } => {
  const oldFilters = getFilters(context);
  return {
    new: { ...oldFilters, ...update },
    old: oldFilters,
  };
};
